module.exports = __webpack_public_path__ + "static/media/windshield.e3800453.svg";